import { create } from "zustand";
import { COUPLEUR_PAR_PBO, LIST_PBO } from "../../Utils/constant";
import { find } from "../../services/service";
export const usePBOStore = create((set) => ({
  loading: false,
  data: [],
  count: 1,
  coupleurs: [],
  countCoupleur: 1,
  loadingCoupleur: false,
  getData: async (params) => {
    set({
      loading: true,
      data: [],
      count: 1,
    });

    try {
      const getItems = await find(`${LIST_PBO}?${params}`);
      set({
        loading: false,
        data: getItems.data,
        count: getItems.data.totalPages,
      });
    } catch (error) {
      set({
        loading: true,
        data: [],
        count: 1,
      });
    }
  },
  getCoupleurByPBO: async (id) => {
    set({
      coupleurs: [],
      loadingCoupleur: true,
      countCoupleur: 1,
    });

    try {
      const getItems = await find(`${COUPLEUR_PAR_PBO}/${id}`);
      set({
        loadingCoupleur: false,
        coupleurs: getItems.data.totalPages,
      });
    } catch (error) {
      set({
        loadingCoupleur: true,
        coupleurs: [],
        countCoupleur: 1,
      });
    }
  },
}));
